export const localStorageKeys = {
  REDIRECT_AFTER_LOGIN: 'redirectAfterLogin',
  ENTRANCE_TEST: 'entranceTest',
}
